import { useEffect, useState } from "react";
import { useDeposito } from "../helpers/useDepositos";
import { useConfiguracion } from "../helpers/useConfiguration";
import { Box } from "@mui/material";
import MenuSection from "../components/MenuSection";
import FormularioVoluntario from "../components/control-strock-components/FormularioVoluntario";
import FormularioAlAzar from "../components/control-strock-components/FormularioAlAlazar";
import FormularioSelectivo from "../components/control-strock-components/FormularioSelectivo";
import BotonesControlStock from "../components/control-strock-components/BotonesControlStock";
import { DialogCancelar } from "../components/control-strock-components/DialogCancelar";
import DialogProximo from "../components/control-strock-components/DialogProximo";
import DialogFinalizar from "../components/control-strock-components/DialogFinalizar";

const ControlDeStockPage = () => {
  useDeposito();
  const { configuracion } = useConfiguracion();
  const [modalWidth, setModalWidth] = useState(window.innerWidth < 700 ? "360px" : "900px");

  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth < 700) {
        setModalWidth("360px");
      } else {
        setModalWidth("900px");
      }
    };

    handleResize();
    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  return (
    <>
      <MenuSection />
      <Box
        sx={{
          width: modalWidth,
          backgroundColor: "white",
          height: window.innerWidth < 700 ? "80%" : "86%",
          mt: 2,
        }}
      >
        {configuracion?.tipoControl === "Voluntario" && (
          <>
            <FormularioVoluntario />
            <BotonesControlStock />
          </>
        )}

        {configuracion?.tipoControl === "AlAzar" && <FormularioAlAzar />}
        {configuracion?.tipoControl === "Selectivo" && <FormularioSelectivo />}

        <DialogCancelar />
        <DialogProximo />
        <DialogFinalizar />
      </Box>
    </>
  );
};

export default ControlDeStockPage;
